<template>
  <div>
    <el-row>
      <CoreTableContainer
        CustomTableArticle
        :columns="containerTableColumns"
        :serverUrl="containerServerUrl"
        :baseUrl="containerBaseUrl"
        :tableToolConfig="tableToolConfig"
        ref="CoreTableContainer"
      >
        <template v-slot:tools>
          <router-link :to="containerBaseUrl + '/add'">
            <el-button type="primary" icon="el-icon-circle-plus-outline">增加后台用户</el-button>
          </router-link>
        </template>

        <template v-slot:filter>
          <PartyOrgCascader @onValueChanged="onPartyOrgValueChanged"></PartyOrgCascader>
          <UnitCascader  @onValueChanged="onClassUnitValueChanged"></UnitCascader>          
        </template>

        <!--  -->
        <template v-slot:table__footer__info>后台用户列表</template>
      </CoreTableContainer>

      <!-- <el-row>
          <p class="paragraph-content-small grey asset"><i class="el-icon-info"></i> 当前列表项的显示顺序，即是网站相关项目的显示顺序。</p>
      </el-row>-->
    </el-row>
  </div>
</template>

<script>
import { CoreTableContainer } from "@/core/table/";
import {PartyOrgCascader,UnitCascader} from "@/views/components/select"

export default {
  name: "muser",
  components: {
    CoreTableContainer,
    PartyOrgCascader,
    UnitCascader
  },
  data() {
    return {
      // table 头
      containerTableColumns: [
        {
          prop: "username",
          label: "用户名",
          width: "200px"
        },
        {
          prop: "rid",
          label: "类型",
          width: "200px",
          convert: (val)=>{
            if(val == '00002'){
              return "单位管理员"
            }
            else if(val == '00003'){
              return "支部管理员"
            }
            else if (val === '00001'){
              return '系统管理员'
            }
            return val;
          }
        },
        {
          prop: "partyTitle",
          label: "相关支部",
          width: "200px"
        },
        {
          prop: "unitTitle",
          label: "相关单位",
          width: "200px"
        },
      ],
      // 基础地址
      containerBaseUrl : "/standard/muser",
      // api的基础地址
      // eslint-disable-next-line no-undef
      containerServerUrl :  "/api/manager/muser",
      // table config 设置
      tableToolConfig : {
        canEdit: true,
        canRecover: true,
        canDelete: true,
        canDisable: true
      },

      // 搜索功能依据的 data.prop
      searchProp : "username"
    }
  },
  methods: {
    onPartyOrgValueChanged(val){
      console.log("onPartyOrgValueChanged",val)


      this.$refs.CoreTableContainer.updateParams("pids",val)


    },
    onClassUnitValueChanged(val){
      console.log("onClassUnitValueChanged",val)
      this.$refs.CoreTableContainer.updateParams("unitids",val)

    }
  }
}
</script>







<style scoped>
</style>

